export function parseTimezoneOffset(tz) {
    if (!tz) return 0
    const m = tz.match(/UTC([+-]\d+)/)
    return m ? Number(m[1]) * 3600 : 0
}

export function eventTsToUTCDate(ts, timezoneUtc) {
    const offset = parseTimezoneOffset(timezoneUtc)
    return new Date((ts - offset) * 1000)
}
export function utcTsToIsoInEventTz(ts, eventTz) {
    const offset = parseTimezoneOffset(eventTz)
    const localTs = ts + offset
    const d = new Date(localTs * 1000)

    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2,'0')}-${String(d.getUTCDate()).padStart(2,'0')}`
}
export function utcTsToIsoDayInEventTz(ts, eventTz) {
    const offset = parseTimezoneOffset(eventTz)
    const localTs = ts + offset
    const d = new Date(localTs * 1000)

    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`
}
export function formatEventDayLabel(ts, eventTz) {
    const offset = parseTimezoneOffset(eventTz)
    const localTs = ts + offset
    const d = new Date(localTs * 1000)

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ]

    return `${monthNames[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`
}
